<template>
  <div class="comment">
    <div class="comment-head">
      <div class="comment-head__title">
        <strong class="font--16px font--600">댓글 <span class="comment__count">{{comment.count | number}}</span></strong>
        <a
          @click="toggleFilter"
          class="comment__mycomment"
        >
          <template v-if="filter === ''">
            <span>내 댓글</span> <i class="material-icons">navigate_next</i>
          </template>
          <template v-else>
            <span>모두의 댓글</span> <i class="material-icons">navigate_before</i>
          </template>
        </a>
      </div>

      <div class="comment__input">
        <comment-input :create="create"></comment-input>
      </div>
    </div>
    <div class="comment-body">
      <comment-sort
        :order="order"
        @changeOrder="changeOrder"
      ></comment-sort>
      <comment
        v-for="row in comment.rows"
        :key="row.seq"
        :row="row"
        :create="create"
        :isFilter="filter !== ''"
      ></comment>
    </div>
    <div class="comment-foot">
      <div
        class="btn--comment-more"
        v-if="comment.count > comment.rows.length"
      >
        <button
          type="button"
          @click="more"
        >더보기 <i class="material-icons">expand_more</i></button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/etc/config'

export default {
  data () {
    return {
      order: 'date',
      filter: '',
      comment: {
        count: 0,
        rows: []
      },
      pages: {
        currentPage: 0,
        limit: config.comment.limit
      }
    }
  },
  created () {
    this.search()
  },
  computed: {
    ...mapState(['user', 'boardMetas']),
    boardId () {
      return this.$route.params.boardId
    },
    seq () {
      return this.$route.params.seq
    },
    boardMeta () {
      return this.boardMetas[this.boardId]
    },
    boardName () {
      return this.boardMeta.boardName
    },
    isAdminMode () {
      return this.$route.name.startsWith('admin')
    }
  },
  methods: {
    async search () {
      try {
        let params = {
          useFlag: 'Y',
          page: this.pages.currentPage,
          limit: this.pages.limit,
          order: this.order
          // ...this.$utils.params('order')
        }

        const res = await this.$http.get(`/api/boards/${this.boardId}/seqs/${this.seq}/comments/${this.filter}`, { params })
        console.log('comments', res.data)
        this.comment.count = res.data.count
        if (this.pages.currentPage === 0) {
          this.comment.rows = res.data.rows
        } else {
          this.comment.rows = this.comment.rows.concat(res.data.rows)
        }
      } catch (ex) {
        console.log(ex)
      } finally {
        // this.loading = false
      }
    },
    async create (content) {
      const uri = `/api/boards/${this.boardId}/seqs/${this.seq}/comments`
      await this.$http.post(uri, { content })

      this.clear()
      this.search()
    },
    async more () {
      this.pages.currentPage += 1
      this.search()
      // this.$router.replace({ name, query })
    },
    clear () {
      this.comment.count = 0
      this.comment.rows = []
      this.pages.currentPage = 0
    },
    changeOrder (type) {
      this.order = type

      this.clear()
      this.search()
    },
    toggleFilter () {
      this.filter = this.filter === '' ? 'mine' : ''

      this.clear()
      this.search()
    }
  },
  components: {
    CommentInput: () => import('@/component/ui2/comment/CommentInput'),
    CommentSort: () => import('@/component/ui2/comment/CommentSort'),
    Comment: () => import('@/component/ui2/comment/Comment')
  }
}
</script>
